import React from "react";

function NotFound(props) {
  
  return (
    <React.Fragment>
      <div className="container" data-testid="not-found-page">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        {/* Dark pass 2026-09-09 (re-ink only — same bootstrap markup, no DS migration).
            `.alert-danger` + `.bg-white` painted the light-only look (bg-white is !important,
            so it has to go, not be overridden). The `.alert` box stays; the surface/edge/ink
            tokens carry the ground, the heading keeps the error mark via the danger glyph
            token, and links take the accent token. */}
        <div
          className="alert tw-bg-surface tw-border-edge tw-text-ink"
          role="alert"
          data-testid="not-found-page-card"
        >
          <h4 className="alert-heading tw-text-tone-danger-glyph" data-testid="not-found-page-title">Oops!</h4>
          <p className="tw-text-ink-secondary">
            Looks like something went wrong . We are investigating this issue.
            <br />
            Thanks for helping us to find this issue. We are sorry for the
            inconvinience caused
          </p>
          <hr className="tw-bg-edge tw-opacity-100" />
          <p className="mb-0 tw-text-ink-secondary">
            If you are lost , Please click&nbsp;
            <a href="/login" className="tw-text-accent hover:tw-text-accent-hover" data-testid="not-found-page-login-link">here</a>&nbsp;to login back
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}

export default NotFound;
